module.exports = __webpack_public_path__ + "img/bg-large.fe849103.svg";